module.exports = /******/
function(modules) {
    /******/
    /******/
    // The require function
    /******/
    function __webpack_require__(moduleId) {
        /******/
        /******/
        // Check if module is in cache
        /******/
        if (installedModules[moduleId]) /******/
        return installedModules[moduleId].exports;
        /******/
        /******/
        // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
            /******/
            exports: {},
            /******/
            id: moduleId,
            /******/
            loaded: !1
        };
        /******/
        /******/
        // Return the exports of the module
        /******/
        /******/
        /******/
        // Execute the module function
        /******/
        /******/
        /******/
        // Flag the module as loaded
        /******/
        return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
        module.loaded = !0, module.exports;
    }
    // webpackBootstrap
    /******/
    // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/
    // Load entry module and return exports
    /******/
    /******/
    /******/
    /******/
    // expose the modules object (__webpack_modules__)
    /******/
    /******/
    /******/
    // expose the module cache
    /******/
    /******/
    /******/
    // __webpack_public_path__
    /******/
    return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
    __webpack_require__.p = "", __webpack_require__(0);
}([ /* 0 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = __webpack_require__(1);
}, /* 1 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.DynamicTable = exports.default = void 0;
    var _stateless = __webpack_require__(2);
    Object.defineProperty(exports, "DynamicTable", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_stateless).default;
        }
    });
    var _stateful = __webpack_require__(20), _stateful2 = _interopRequireDefault(_stateful);
    exports.default = _stateful2.default;
}, /* 2 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function toggleSortOrder(currentSortOrder) {
        switch (currentSortOrder) {
          case _constants.DESC:
            return _constants.ASC;

          case _constants.ASC:
            return _constants.DESC;

          default:
            return currentSortOrder;
        }
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(3), _extends3 = _interopRequireDefault(_extends2), _objectWithoutProperties2 = __webpack_require__(4), _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2), _getPrototypeOf = __webpack_require__(5), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(6), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(7), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(8), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(9), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(10), _react2 = _interopRequireDefault(_react), _pagination = __webpack_require__(11), _constants = __webpack_require__(12), _props6 = __webpack_require__(13), _styled = __webpack_require__(16), DynamicTable = function(_Component) {
        function DynamicTable() {
            var _ref, _temp, _this, _ret;
            (0, _classCallCheck3.default)(this, DynamicTable);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
            return _temp = _this = (0, _possibleConstructorReturn3.default)(this, (_ref = DynamicTable.__proto__ || (0, 
            _getPrototypeOf2.default)(DynamicTable)).call.apply(_ref, [ this ].concat(args))), 
            _this.onSort = function(item) {
                return function() {
                    var key = item.key;
                    if (key) {
                        var sortOrder = key !== _this.props.sortKey ? _constants.ASC : toggleSortOrder(_this.props.sortOrder);
                        _this.onSetPage(1), _this.props.onSort({
                            key: key,
                            item: item,
                            sortOrder: sortOrder
                        });
                    }
                };
            }, _this.onSetPage = function(page) {
                return _this.props.onSetPage(page);
            }, _ret = _temp, (0, _possibleConstructorReturn3.default)(_this, _ret);
        }
        return (0, _inherits3.default)(DynamicTable, _Component), (0, _createClass3.default)(DynamicTable, [ {
            key: "getSortedRows",
            value: function() {
                var _props = this.props, head = _props.head, rows = _props.rows, sortKey = _props.sortKey, sortOrder = _props.sortOrder;
                if (!sortKey || !head) return rows;
                var getSortingCellValue = function(cells) {
                    return cells.reduce(function(result, cell, index) {
                        return result || head.cells[index].key === sortKey && (void 0 !== cell.key ? cell.key : cell.content);
                    }, null);
                };
                return rows.sort(function(a, b) {
                    var valA = getSortingCellValue(a.cells), valB = getSortingCellValue(b.cells), modifier = sortOrder === _constants.ASC ? 1 : -1;
                    return !valA || valA < valB ? -modifier : !valB || valA > valB ? modifier : 0;
                });
            }
        }, {
            key: "renderCaption",
            value: function() {
                var caption = this.props.caption;
                return caption ? _react2.default.createElement(_styled.Caption, null, caption) : null;
            }
        }, {
            key: "renderHead",
            value: function() {
                var _this2 = this, _props2 = this.props, head = _props2.head, sortKey = _props2.sortKey, sortOrder = _props2.sortOrder;
                if (!head) return null;
                var cells = head.cells, rest = (0, _objectWithoutProperties3.default)(head, [ "cells" ]);
                return _react2.default.createElement(_styled.TableHead, rest, _react2.default.createElement("tr", null, cells.map(function(cell, index) {
                    var isSortable = cell.isSortable, key = cell.key, content = cell.content, restCellProps = (0, 
                    _objectWithoutProperties3.default)(cell, [ "isSortable", "key", "content" ]), isFixedSize = _this2.props.isFixedSize;
                    return _react2.default.createElement(_styled.TableHeadCell, (0, _extends3.default)({
                        key: key || index,
                        onClick: isSortable && _this2.onSort(cell),
                        isFixedSize: isFixedSize,
                        isSortable: isSortable,
                        sortOrder: key === sortKey && sortOrder
                    }, restCellProps), _react2.default.createElement("span", null, content));
                })));
            }
        }, {
            key: "renderBody",
            value: function() {
                var _this3 = this, _props3 = this.props, rowsPerPage = _props3.rowsPerPage, page = _props3.page, rows = this.getSortedRows();
                return _react2.default.createElement("tbody", null, (rows || []).slice((page - 1) * rowsPerPage, page * rowsPerPage).map(function(row, rowIndex) {
                    return _this3.renderBodyRow(row, rowIndex);
                }));
            }
        }, {
            key: "renderBodyRow",
            value: function(row, rowIndex) {
                var _props4 = this.props, head = _props4.head, isFixedSize = _props4.isFixedSize, cells = row.cells, restRowProps = (0, 
                _objectWithoutProperties3.default)(row, [ "cells" ]);
                return _react2.default.createElement(_styled.TableBodyRow, (0, _extends3.default)({
                    key: rowIndex
                }, restRowProps), cells.map(function(cell, cellIndex) {
                    var content = cell.content, restCellProps = (0, _objectWithoutProperties3.default)(cell, [ "content" ]), _ref2 = (head || {
                        cells: []
                    }).cells[cellIndex] || {}, shouldTruncate = _ref2.shouldTruncate, width = _ref2.width;
                    return _react2.default.createElement(_styled.TableBodyCell, (0, _extends3.default)({}, restCellProps, {
                        key: cellIndex,
                        width: width,
                        shouldTruncate: shouldTruncate,
                        isFixedSize: isFixedSize
                    }), content);
                }));
            }
        }, {
            key: "render",
            value: function() {
                var _props5 = this.props, rows = _props5.rows, isFixedSize = _props5.isFixedSize, rowsPerPage = _props5.rowsPerPage, emptyView = _props5.emptyView, page = _props5.page, totalPages = rows ? Math.ceil(rows.length / rowsPerPage) : 0;
                return rows && rows.length ? _react2.default.createElement("div", null, _react2.default.createElement(_styled.Table, {
                    isFixedSize: isFixedSize
                }, this.renderCaption(), this.renderHead(), this.renderBody()), totalPages ? _react2.default.createElement(_pagination.Pagination, {
                    current: page,
                    total: totalPages,
                    onSetPage: this.onSetPage
                }) : null) : emptyView;
            }
        } ]), DynamicTable;
    }(_react.Component);
    DynamicTable.propTypes = _props6.statelessPropTypes, DynamicTable.defaultProps = _props6.statelessDefaultProps, 
    exports.default = DynamicTable;
}, /* 3 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/extends");
}, /* 4 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/objectWithoutProperties");
}, /* 5 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/core-js/object/get-prototype-of");
}, /* 6 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/classCallCheck");
}, /* 7 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/createClass");
}, /* 8 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/possibleConstructorReturn");
}, /* 9 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/inherits");
}, /* 10 */
/***/
function(module, exports) {
    module.exports = require("react");
}, /* 11 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/pagination");
}, /* 12 */
/***/
function(module, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    exports.ASC = "ASC", exports.DESC = "DESC";
}, /* 13 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function isInteger(props, propName, componentName) {
        if (void 0 === props[propName]) return null;
        if (!(0, _isInteger2.default)(props[propName]) && props[propName] !== 1 / 0) {
            var message = "'" + propName + "' should be an integer or an infinity, got " + props[propName] + " instead";
            return (0, _utilCommon.createError)(propName, componentName, message);
        }
        return null;
    }
    function rowCells(props, propName, componentName) {
        for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) rest[_key - 3] = arguments[_key];
        var initialCheck = _react.PropTypes.arrayOf(rowCell).apply(void 0, [ props, propName, componentName ].concat(rest));
        if (initialCheck instanceof Error) return initialCheck;
        if (!props.head || !props.head.cells) return null;
        var isAllRowsSameLength = props[propName].reduce(function(result, row) {
            return result && row.length === props.head.cells.length;
        }, !0);
        return isAllRowsSameLength ? null : (0, _utilCommon.createError)(propName, componentName, "One of the rows has different cell-count compared to head.");
    }
    function isSortable(props, propName, componentName) {
        for (var _len2 = arguments.length, rest = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) rest[_key2 - 3] = arguments[_key2];
        var initialCheck = _react.PropTypes.bool.apply(_react.PropTypes, [ props, propName, componentName ].concat(rest));
        return initialCheck instanceof Error ? initialCheck : props[propName] && !props.key ? (0, 
        _utilCommon.createError)(propName, componentName, "'" + propName + "' can't be set to true, if the 'key' prop is missing.") : null;
    }
    function sortKey(props, propName, componentName) {
        if (!props[propName]) return null;
        var headHasKey = props.head.cells.map(function(cell) {
            return cell.key;
        }).includes(props[propName]);
        return headHasKey ? null : (0, _utilCommon.createError)(propName, componentName, "Cell with " + props[propName] + " key not found in head.");
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.statefulDefaultProps = exports.statelessDefaultProps = exports.statefulPropTypes = exports.statelessPropTypes = void 0;
    var _extends2 = __webpack_require__(3), _extends3 = _interopRequireDefault(_extends2), _isInteger = __webpack_require__(14), _isInteger2 = _interopRequireDefault(_isInteger), _react = __webpack_require__(10), _utilCommon = __webpack_require__(15), _constants = __webpack_require__(12);
    isInteger.isRequired = !1;
    var rowCellObject = {
        key: _react.PropTypes.oneOfType([ _react.PropTypes.number, _react.PropTypes.string, _react.PropTypes.bool ]),
        content: _react.PropTypes.node
    }, rowCell = _react.PropTypes.shape(rowCellObject);
    isSortable.isRequired = !1;
    var headCellObject = (0, _extends3.default)({}, rowCellObject, {
        isSortable: isSortable,
        width: _react.PropTypes.number,
        shouldTruncate: _react.PropTypes.bool
    }), headCell = _react.PropTypes.shape(headCellObject), head = _react.PropTypes.shape({
        cells: _react.PropTypes.arrayOf(headCell)
    }), rows = _react.PropTypes.arrayOf(_react.PropTypes.shape({
        cells: rowCells
    }));
    sortKey.isRequired = !1;
    var caption = _react.PropTypes.node, sortOrder = _react.PropTypes.oneOf([ _constants.ASC, _constants.DESC ]), isFixedSize = _react.PropTypes.bool, rowsPerPage = isInteger, page = isInteger, onSetPage = _react.PropTypes.func, onSort = _react.PropTypes.func, emptyView = _react.PropTypes.node, commonPropTypes = {
        caption: caption,
        head: head,
        rows: rows,
        emptyView: emptyView,
        isFixedSize: isFixedSize,
        rowsPerPage: rowsPerPage,
        onSetPage: onSetPage,
        onSort: onSort
    }, commonDefaultProps = {
        caption: null,
        head: null,
        rows: null,
        emptyView: null,
        isFixedSize: !1,
        rowsPerPage: 1 / 0,
        onSetPage: function() {},
        onSort: function() {}
    };
    exports.statelessPropTypes = (0, _extends3.default)({}, commonPropTypes, {
        page: page,
        sortKey: sortKey,
        sortOrder: sortOrder
    }), exports.statefulPropTypes = (0, _extends3.default)({}, commonPropTypes, {
        defaultPage: page,
        defaultSortKey: sortKey,
        defaultSortOrder: sortOrder
    }), exports.statelessDefaultProps = (0, _extends3.default)({}, commonDefaultProps, {
        page: 1,
        sortKey: null,
        sortOrder: null
    }), exports.statefulDefaultProps = (0, _extends3.default)({}, commonDefaultProps, {
        defaultPage: 1,
        defaultSortKey: null,
        defaultSortOrder: null
    });
}, /* 14 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/core-js/number/is-integer");
}, /* 15 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/util-common");
}, /* 16 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.TableBodyCell = exports.TableBodyRow = exports.TableHeadCell = exports.TableHead = exports.Caption = exports.Table = void 0;
    var _taggedTemplateLiteral2 = __webpack_require__(17), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  ", "\n  ", ";\n  ", "\n" ], [ "\n  ", "\n  ", ";\n  ", "\n" ]), _templateObject2 = (0, 
    _taggedTemplateLiteral3.default)([ "width: ", "%;" ], [ "width: ", "%;" ]), _templateObject3 = (0, 
    _taggedTemplateLiteral3.default)([ "overflow: hidden;" ], [ "overflow: hidden;" ]), _templateObject4 = (0, 
    _taggedTemplateLiteral3.default)([ "\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  " ], [ "\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  " ]), _templateObject5 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  &:hover {\n    cursor: pointer;\n  }\n" ], [ "\n  &:hover {\n    cursor: pointer;\n  }\n" ]), _templateObject6 = (0, 
    _taggedTemplateLiteral3.default)([ "\n    position: absolute;\n    display: block;\n    width: 0;\n    height: 0;\n    right: -", "px;\n    border: 3px solid transparent;\n  " ], [ "\n    position: absolute;\n    display: block;\n    width: 0;\n    height: 0;\n    right: -", "px;\n    border: 3px solid transparent;\n  " ]), _templateObject7 = (0, 
    _taggedTemplateLiteral3.default)([ "\n    & > span {\n      position: relative;\n        &:before {\n          ", ";\n            content: ' ';\n            bottom: 8px;\n            border-bottom: 3px solid ", "; \n          };\n        &:after {\n          ", ";\n          content: ' ';\n          bottom: 0;  \n          border-top: 3px solid ", ";       \n        };\n      }\n        \n      &:hover > span {\n        &:before {\n          border-bottom: 3px solid ", "; \n        }\n        &:after {\n          border-top: 3px solid ", "; \n        }\n      }\n    " ], [ "\n    & > span {\n      position: relative;\n        &:before {\n          ", ";\n            content: ' ';\n            bottom: 8px;\n            border-bottom: 3px solid ", "; \n          };\n        &:after {\n          ", ";\n          content: ' ';\n          bottom: 0;  \n          border-top: 3px solid ", ";       \n        };\n      }\n        \n      &:hover > span {\n        &:before {\n          border-bottom: 3px solid ", "; \n        }\n        &:after {\n          border-top: 3px solid ", "; \n        }\n      }\n    " ]), _templateObject8 = (0, 
    _taggedTemplateLiteral3.default)([ "\n    padding: ", "px ", "px;\n    border: none;\n    text-align: left;    \n    &:first-child {\n      padding-left: 0;\n    }\n    &:last-child {\n      padding-right: 0;\n    }\n" ], [ "\n    padding: ", "px ", "px;\n    border: none;\n    text-align: left;    \n    &:first-child {\n      padding-left: 0;\n    }\n    &:last-child {\n      padding-right: 0;\n    }\n" ]), _templateObject9 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  ", ";\n  width: 100%;\n  border-collapse: collapse;\n" ], [ "\n  ", ";\n  width: 100%;\n  border-collapse: collapse;\n" ]), _templateObject10 = (0, 
    _taggedTemplateLiteral3.default)([ "table-layout: fixed;" ], [ "table-layout: fixed;" ]), _templateObject11 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  font-size: 1.42857143em;\n  font-style: inherit;\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  line-height: 1.2;\n  margin-top: ", "px;\n  margin-bottom: ", "px;\n  text-align: left;\n" ], [ "\n  font-size: 1.42857143em;\n  font-style: inherit;\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  line-height: 1.2;\n  margin-top: ", "px;\n  margin-bottom: ", "px;\n  text-align: left;\n" ]), _templateObject12 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  border-bottom: 2px solid #DFE1E6;\n" ], [ "\n  border-bottom: 2px solid #DFE1E6;\n" ]), _templateObject13 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  ", "\n  ", "\n  ", "\n  ", "\n  position: relative;\n  vertical-align: top;\n  text-align: left;\n  border: none;\n  font-size: 12px;\n  color: ", ";\n  fontWeight: 600;\n" ], [ "\n  ", "\n  ", "\n  ", "\n  ", "\n  position: relative;\n  vertical-align: top;\n  text-align: left;\n  border: none;\n  font-size: 12px;\n  color: ", ";\n  fontWeight: 600;\n" ]), _templateObject14 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  ", "\n  &:hover {\n    background: ", ";\n  }\n" ], [ "\n  ", "\n  &:hover {\n    background: ", ";\n  }\n" ]), _templateObject15 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  ", "\n  ", "\n  ", "  \n" ], [ "\n  ", "\n  ", "\n  ", "  \n" ]), _styledComponents = __webpack_require__(18), _styledComponents2 = _interopRequireDefault(_styledComponents), _utilSharedStyles = __webpack_require__(19), _constants = __webpack_require__(12), gridUnit = parseInt(_utilSharedStyles.akGridSize, 10), baselineUnit = gridUnit / 2, truncateStyle = function(_ref) {
        var width = _ref.width, isFixedSize = _ref.isFixedSize, shouldTruncate = _ref.shouldTruncate;
        return (0, _styledComponents.css)(_templateObject, width ? (0, _styledComponents.css)(_templateObject2, width) : "", isFixedSize ? (0, 
        _styledComponents.css)(_templateObject3) : "", isFixedSize && shouldTruncate ? (0, 
        _styledComponents.css)(_templateObject4) : "");
    }, onClickStyle = function(_ref2) {
        var onClick = _ref2.onClick;
        return onClick && (0, _styledComponents.css)(_templateObject5);
    }, arrowsStyle = function(_ref3) {
        var isSortable = _ref3.isSortable, sortOrder = _ref3.sortOrder;
        if (!isSortable) return "";
        var pseudoBase = (0, _styledComponents.css)(_templateObject6, gridUnit);
        return (0, _styledComponents.css)(_templateObject7, pseudoBase, sortOrder === _constants.ASC ? _utilSharedStyles.akColorN300 : _utilSharedStyles.akColorN40, pseudoBase, sortOrder === _constants.DESC ? _utilSharedStyles.akColorN300 : _utilSharedStyles.akColorN40, sortOrder === _constants.ASC ? _utilSharedStyles.akColorN300 : _utilSharedStyles.akColorN60, sortOrder === _constants.DESC ? _utilSharedStyles.akColorN300 : _utilSharedStyles.akColorN60);
    }, cellStyle = (0, _styledComponents.css)(_templateObject8, baselineUnit, gridUnit);
    exports.Table = _styledComponents2.default.table(_templateObject9, function(_ref4) {
        var isFixedSize = _ref4.isFixedSize;
        return isFixedSize && (0, _styledComponents.css)(_templateObject10);
    }), exports.Caption = _styledComponents2.default.caption(_templateObject11, 7 * baselineUnit, gridUnit), 
    exports.TableHead = _styledComponents2.default.thead(_templateObject12), exports.TableHeadCell = _styledComponents2.default.th(_templateObject13, function(props) {
        return onClickStyle(props);
    }, function(props) {
        return truncateStyle(props);
    }, function(props) {
        return arrowsStyle(props);
    }, function() {
        return cellStyle;
    }, _utilSharedStyles.akColorN300), exports.TableBodyRow = _styledComponents2.default.tr(_templateObject14, function(props) {
        return onClickStyle(props);
    }, _utilSharedStyles.akColorN10), exports.TableBodyCell = _styledComponents2.default.td(_templateObject15, function(props) {
        return onClickStyle(props);
    }, function(props) {
        return truncateStyle(props);
    }, function() {
        return cellStyle;
    });
}, /* 17 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/taggedTemplateLiteral");
}, /* 18 */
/***/
function(module, exports) {
    module.exports = require("styled-components");
}, /* 19 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/util-shared-styles");
}, /* 20 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(5), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(6), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(7), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(8), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(9), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(10), _react2 = _interopRequireDefault(_react), _stateless = __webpack_require__(2), _stateless2 = _interopRequireDefault(_stateless), _props = __webpack_require__(13), AkDynamicTable = function(_PureComponent) {
        function AkDynamicTable() {
            var _ref, _temp, _this, _ret;
            (0, _classCallCheck3.default)(this, AkDynamicTable);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
            return _temp = _this = (0, _possibleConstructorReturn3.default)(this, (_ref = AkDynamicTable.__proto__ || (0, 
            _getPrototypeOf2.default)(AkDynamicTable)).call.apply(_ref, [ this ].concat(args))), 
            _this.state = {
                page: _this.props.defaultPage,
                sortKey: _this.props.defaultSortKey,
                sortOrder: _this.props.defaultSortOrder
            }, _this.onSetPage = function(page) {
                _this.props.onSetPage(page), _this.setState({
                    page: page
                });
            }, _this.onSort = function(_ref2) {
                var key = _ref2.key, item = _ref2.item, sortOrder = _ref2.sortOrder;
                _this.props.onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrder
                }), _this.setState({
                    sortKey: key,
                    sortOrder: sortOrder,
                    page: 1
                });
            }, _ret = _temp, (0, _possibleConstructorReturn3.default)(_this, _ret);
        }
        return (0, _inherits3.default)(AkDynamicTable, _PureComponent), (0, _createClass3.default)(AkDynamicTable, [ {
            key: "componentWillReceiveProps",
            value: function(newProps) {
                this.setState({
                    page: newProps.page,
                    sortKey: newProps.defaultSortKey,
                    sortOrder: newProps.defaultSortOrder
                });
            }
        }, {
            key: "render",
            value: function() {
                return _react2.default.createElement(_stateless2.default, {
                    caption: this.props.caption,
                    head: this.props.head,
                    rows: this.props.rows,
                    emptyView: this.props.emptyView,
                    isFixedSize: this.props.isFixedSize,
                    rowsPerPage: this.props.rowsPerPage,
                    onSetPage: this.onSetPage,
                    onSort: this.onSort,
                    page: this.state.page,
                    sortKey: this.state.sortKey,
                    sortOrder: this.state.sortOrder
                });
            }
        } ]), AkDynamicTable;
    }(_react.PureComponent);
    AkDynamicTable.propTypes = _props.statefulPropTypes, AkDynamicTable.defaultProps = _props.statefulDefaultProps, 
    exports.default = AkDynamicTable;
} ]);


//////////////////
// WEBPACK FOOTER
// ./~/@atlaskit/dynamic-table/dist/bundle-cjs.js
// module id = 346
// module chunks = 0